export class DownloadEvidenceRequest {
  constructor(public Description: string | null) {}
}
